import { Injectable } from '@angular/core';
import introJs from 'intro.js/intro.js';

@Injectable({ providedIn: 'root' })
export class IntroJSService {
  introJs = null;

  showHelp(offset = 0) {
    this.introJs.start();
  }

  interactiveSchedule() {
    this.introJs = introJs();

    this.introJs.start();

    this.introJs.setOptions({});

    this.introJs
      .setOptions({
        dontShowAgain: true,
        tooltipClass: 'introjs-class',
        steps: [
          {
            title: 'Tour',
            intro: 'Hello. Take the tour to learn the features available in this tool',
          },
          {
            element: '#intro-calendar',
            title: 'Date Range',
            intro: 'Click here to change the range of dates displayed',
          },
          {
            element: '#intro-daterange',
            intro: 'The currently selected date range shows here',
          },
          {
            element: '#intro-task-1',
            title: 'Tasks',
            intro: 'This is a list of task you can choose from',
          },
          {
            element: '#viewfilters-button',
            title: 'Change filters',
            intro: 'Change your search filters here',
          },
          {
            title: 'Adding Task to Calendar',
            intro:
              'Clicking a task will add it to your calendar in <span class="preview-mode">preview</span> mode<br/><br/><img src="../../assets/images/schedule/schedule-sampletask.jpg" width="100%">',
          },
          {
            title: 'Task Information',
            intro:
              'To see more information on a task, click the info button <br/><br/><img src="../../assets/images/schedule/schedule-taskinfo.jpg" width="100%">',
          },
          {
            title: 'Accepting the Task',
            intro:
              'To accept the job, click the tick <br/><br/><img src="../../assets/images/schedule/schedule-taskbuy.jpg" width="100%">',
          },
          {
            title: 'Change Start/End Times',
            intro:
              'To move the start/end time (without moving the entire job) you can change the time using the grab-handles <br/><br/><img src="../../assets/images/schedule/schedule-task-retime.jpg" width="100%">',
          },
          {
            title: 'Moving Task',
            intro:
              'You can move tasks in your schedule by click + dragging them.  When dragging, you are shown the pick up window (in blue) and the dropoff window (in pink).<br/></br/><img width="100%" alt="" src="../../assets/images/schedule/schedule-pinkblue.png">',
          },
          {
            title: 'Task Window',
            intro:
              'Tasks can only be moved to an allowed range of times.  When dragging, these red bars show where you cannot move the task to.<br/></br/><img width="100%" alt="" src="../../assets/images/schedule/schedule-outofbounds.png">',
          },
          {
            title: 'Approving changes',
            element: '#save-times',
            intro:
              'Time changes will need to be approved if the task has already been assigned to a supplier by clicking this button',
          },
          {
            title: 'Working hours',
            element: '#intro-clock',
            intro: 'Click here to toggle between working-hours and 24-hour view',
          },
          {
            element: '#legend',
            position: 'left',
            title: 'Drivers',
            intro:
              'This is a list of drivers. You can toggle which drivers will have their jobs displayed on the grid. (This window can be moved, by dragging it)',
          },
          {
            element: '#dayDate-0',
            title: 'Availability',
            intro:
              'This shows your availability for this date.<br/>' +
              '<span class="square available"></span> Available<br/>' +
              '<span class="square unavailable"></span> Unavailable<br/>' +
              '<span class="square unknown"></span> Unknown<br/>Click the date to change your availability',
          },
          {
            element: '#facetsuppliers',
            title: 'Suppliers',
            position: 'left',
            intro: 'Here is a list of suppliers you can select from',
          },
          {
            element: '#facet-suppliers-chosen',
            title: 'Selected Suppliers',
            intro: 'Suppliers to be displayed on the grid are shown here',
          },
          {
            title: 'Reassign Task',
            intro:
              '(If you have more than one driver) You can reassign a task by double-clicking the task and selecting the new driver from the list',
          },
        ].filter((obj) => {
          return !obj.element || $(obj.element).length; // This ensures only elements on the page are used
        }),
      })
      .start();
  }
}
